import axios from 'axios'
import { take, call, put, fork, cancel, select } from 'redux-saga/effects'

  
  import { TOKEN_STAKING_ACC, NFT_INFO_ACC, FIRST_EPOCH_DATE,  } from '../../app/constants'
import { setStakeInfo } from '../../features/staking/stakeInfoSlice'

// Query the NFTs the user will be able to stake for each Slot
export function queryNFTs(userAccount) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await userAccount.rpc.get_table_rows({
        json: true,
        code: NFT_INFO_ACC,
        scope: NFT_INFO_ACC,
        table: 'nfttypecfg',
        limit: 100,
      })
      resolve(rows)
      console.log('debbuging stakeInfo', rows)
    } catch (error) {
      console.log('ERROR ON QUERY NFT:', error)
      reject(error)
    }
  })
}

export function getStakedSparks(user) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_STAKING_ACC,
        scope: TOKEN_STAKING_ACC,
        lower_bound: user.accountName,
        upper_bound: user.accountName,
        key_type: 'i64',
        index_position: 2,
        table: 'sparks',
        limit: 10,
      })
      resolve(rows)
      console.log('ERROR ON SPARKS STAKED:', rows)
    } catch (error) {
      console.log('ERROR ON SPARKS STAKED:', error)
      reject(error)
    }
  })
}

// Query NFT staking details for all users for current epoch
export function getUserNFTstakeDetails(user) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_STAKING_ACC,
        scope: TOKEN_STAKING_ACC,
        lower_bound: user.accountName,
        upper_bound: user.accountName,
        key_type: 'name',
        index_position: 2,
        table: 'stakecards',
        limit: 1000,
      })
      resolve(rows)
      console.log('debbuging stakeInfo', rows)
    } catch (error) {
      console.log('ERROR ON NFT STAKE DETAILS:', error)

      reject(error)
    }
  })
}

// FIXME - Smart Contract table seems to be empty
// Query the stake slots to build the smart contract memo for user staking

export function queryStakeSlot(userAccount, epoch) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await userAccount.rpc.get_table_rows({
        json: true,
        code: TOKEN_STAKING_ACC,
        scope: TOKEN_STAKING_ACC,
        table: 'stakeslot',
        lower_bound: epoch,
        upper_bound: epoch,
        key_type: 'i64',
        index_position: 2,
        limit: 1000,
      })
      resolve(rows)
      console.log('debbuging stakeslot', rows)
    } catch (error) {
      console.log('debbuging stakeslot:', error)

      reject(error)
    }
  })
}

export function queryNFTData(ids) {
  return new Promise(async (resolve, reject) => {
    if (ids.length < 1) {
      return []
    }
    try {
      const collection = await axios.get(
        // Mainnet
        // 'https://wax.api.atomicassets.io/atomicassets/v1/templates?collection_name=galaktikanft&limit=1000&order=desc&sort=name'
        //  Testnet
        `https://test.wax.api.atomicassets.io/atomicassets/v1/assets?collection_name=galaktiktest&limit=${
          ids.length
        }&order=desc&sort=name&ids=${ids.join(',')}`,
      )
      resolve(collection)
      console.log('All stakeInfo:', collection)
      return collection
    } catch (error) {
      console.log('DEBUGGING STAKE INFO', error)
      reject(error)
    }
  })
}

export function* resolveNFTs() {
  const data = yield select()
  console.log('DEBUGGING EPOCH:', data.epoch.epoch)
  const today = new Date()

  const releaseDate = FIRST_EPOCH_DATE
  const era = parseInt((today - releaseDate) / (1000 * 60 * 60 * 24))

  console.log('DEBUGGING EPOCH:', era)

  try {
    const NFTs = yield call(queryNFTs, data.user.userAccount)

    console.log('DEBUG NFTTYPEID1 :', NFTs)

    const stakeSlots = yield call(queryStakeSlot, data.user.userAccount, era)
    console.log('DEBUG NFTTYPEID2 :', stakeSlots)

    const userNFTStakingDetailsFetch = yield call(
      getUserNFTstakeDetails,
      data.user,
    )

    console.log('DEBUG NFTTYPEID3  :', stakeSlots)

    let nftData

    if (userNFTStakingDetailsFetch.length > 0)
      nftData = yield call(
        queryNFTData,
        userNFTStakingDetailsFetch
          ?.map((e) => e.asset_ids)
          .reduce((a, b) => {
            return [...a, ...b]
          }, []),
      )
    console.log('DEBUG NFTTYPEID4:', stakeSlots, nftData?.data?.data)

    const userNFTStakingDetails = userNFTStakingDetailsFetch.map((e) => {
      e.nftType_id = stakeSlots.find(
        (i) => i?.id === e?.stake_slot_id,
      )?.nft_type_id
      e.data = nftData?.data?.data?.filter(
        (i) => e?.asset_ids.includes(i?.asset_id),
      ).map(e => e?.data) || [];
      return e
    })
    console.log('DEBUG NFTTYPEID:', userNFTStakingDetails, stakeSlots, nftData)

    const sparks = yield call(
      getStakedSparks,
      data.user,
    )

    const sparksAmount = sparks.length

    yield put(
      setStakeInfo({
        type: 'GET_STAKEINFO_SUCCESS',
        stakingCards: NFTs,
        stakeSlots,
        userNFTStakingDetails,
        sparks,
        sparksAmount
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setStakeInfo({ type: 'GET_STAKEINFO_ERROR', error: errorMsg }))
  }
}

export function* stakeInfoFlow() {
  while (true) {
    yield put(setStakeInfo({ type: 'GET_STAKEINFO_START' }))
    const task = yield fork(resolveNFTs)
    const action = yield take(['GET_STAKEINFO_ERROR'])
    if (action.type === 'GET_STAKEINFO_ERROR') {
      yield cancel(task)
    }
  }
}
